/**
 * Filtres et tri de la liste d'exercices, mémorisés pour l'écran de détail.
 *
 * 🔴 La liste, la navigation précédent / suivant du détail et l'ouverture du
 * « premier exercice » depuis la couverture taxonomique lisent TOUS ces filtres
 * ici et les envoient par `parametresApiListe` : le serveur les interprète d'une
 * seule façon (`backend/services/adminExercicesListe.js`). Avant, chaque écran
 * recopiait sa sélection et en oubliait une partie.
 *
 * Taxonomie : clé absente = pas de filtre ; chaîne vide = niveau ABSENT (les
 * exercices sans notion, ouverts depuis la couverture).
 */

const CLE = 'exerciseFilters';
const CLE_PAGE = 'exerciseListPage';

export const FILTRES_PAR_DEFAUT = Object.freeze({
  gameType: '',
  type: '',
  active: '',
  source: '',
  flagged: '',
  validationStatus: '',
  search: '',
  dateFrom: '',
  dateTo: '',
  dateField: 'created_at',
  // Usage (journal des réponses) : parties jouées et taux d'échec en %.
  partiesMin: '',
  partiesMax: '',
  echecMin: '',
  sortBy: 'created_at',
  sortDir: 'DESC',
});

const NIVEAUX_TAXONOMIE = ['domain', 'competence', 'notion'];

export function lireFiltresListe() {
  try {
    const brut = localStorage.getItem(CLE);
    const lus = brut ? JSON.parse(brut) : {};
    return { ...FILTRES_PAR_DEFAUT, ...(lus && typeof lus === 'object' ? lus : {}) };
  } catch {
    return { ...FILTRES_PAR_DEFAUT };
  }
}

export function ecrireFiltresListe(filtres) {
  try {
    localStorage.setItem(CLE, JSON.stringify(filtres));
  } catch {
    // Stockage indisponible : la liste marche, seul le détail perd le contexte.
  }
  return filtres;
}

/** Page courante de la liste, retrouvée au retour du détail. */
export function lirePageListe() {
  try {
    return Math.max(parseInt(sessionStorage.getItem(CLE_PAGE), 10) || 1, 1);
  } catch {
    return 1;
  }
}

export function ecrirePageListe(page) {
  try {
    sessionStorage.setItem(CLE_PAGE, String(page));
  } catch {
    // idem
  }
}

/** Paramètres d'API d'un jeu de filtres de l'écran (noms de l'écran → noms de l'API). */
export function parametresApiListe(filtres = {}) {
  const valeur = (v) => (v === undefined || v === null || v === '' ? undefined : v);
  const params = {
    gameType: valeur(filtres.gameType),
    type: valeur(filtres.type),
    isActive: valeur(filtres.active),
    isFlagged: valeur(filtres.flagged),
    source: valeur(filtres.source),
    validationStatus: valeur(filtres.validationStatus),
    search: valeur(filtres.search?.trim?.() ?? filtres.search),
    dateField: valeur(filtres.dateField),
    dateFrom: valeur(filtres.dateFrom),
    dateTo: valeur(filtres.dateTo),
    partiesMin: valeur(filtres.partiesMin),
    partiesMax: valeur(filtres.partiesMax),
    echecMin: valeur(filtres.echecMin),
    sortBy: valeur(filtres.sortBy),
    sortDir: valeur(filtres.sortDir),
  };
  for (const niveau of NIVEAUX_TAXONOMIE) {
    if (filtres[niveau] !== undefined && filtres[niveau] !== null) params[niveau] = filtres[niveau];
  }
  return params;
}
